import { z } from "zod";

export const BillingTermsSchema = z.object({
  $schema: z.string().optional(),
  billing_frequency: z.enum(["monthly", "yearly"]),
  billing_cycle_day: z.number().optional(),
  payment_due_days: z.number().min(1),
  invoice_delivery_method: z.enum(["email", "mail"]).default("email"),
  payment_methods_allowed: z.object({
    credit_card: z.boolean(),
    bank_transfer: z.boolean(),
    check: z.boolean(),
  }),
  discount_terms: z.object({
    volume_based: z.object({
      threshold: z.literal(100),
    }),
  }),
});
